const TextKeys = {
  Move: 'MOVE',
  Attack: 'ATTACK',
  Skill: 'SKILL',
  End: 'END',
};

export default TextKeys;
